var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"radio-tariff-group",class:{ active: _vm.active, disabled: _vm.disabled }},[_c('span',{staticClass:"radio-click"},[(_vm.active)?_c('span',{staticClass:"radio-active"}):_vm._e()]),_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }